import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export const LoadingSpinner = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
    </Box>
);
